import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import ISO6391 from 'iso-639-1';
import React from 'react';
import { Edit, SelectInput, SimpleForm, TextInput } from 'react-admin';

const GuildMembersList = ({record}: any) => {
  const memberships = record.memberships;

  if (!memberships?.length) {
    return <span></span>;
  }
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        margin: "20px 0",
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
      }}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Joined at</TableCell>
						<TableCell>Account created at</TableCell>
            <TableCell>Role</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {memberships.map((entry: any) => {
            return (
              <TableRow key={entry?.userId}>
								<TableCell>{entry?.userId ? (
                    <a href={`/admin#/users/${entry?.userId}`}>
                      {entry?.userId}
                    </a>
                  ) : (
                    <div>No user found</div>
                  )}{" "}</TableCell>
                <TableCell>{entry?.username}</TableCell>
                <TableCell>{entry?.joinedAt}</TableCell>
                <TableCell>{entry?.accountCreatedAt}</TableCell>
                <TableCell>{entry?.role}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

const getLanguages = () => {
  const languages = ISO6391.getAllNames();
  return languages.map((language) => ({
    id: language,
    name: language,
  }));
}

export const GuildEdit = (props: any) => (
	<Edit {...props}>
		<SimpleForm>
			<img
				src={`${process.env.REACT_APP_BACKEND_REALM}/guilds/${props.id}/icon`}
				alt="Guild Icon"
				style={{ width: 'auto', height: 'auto', maxHeight: '200px', maxWidth: '200px' }}
			/>
			<TextInput disabled label="ID" source="id" />
			<TextInput source="name" label="Name" />
			<TextInput source="tag" label="Tag" />
			<TextInput source="description" label="Description" />
			<TextInput source="requirements" label="Requirements" />
			<SelectInput source="language" label="Language" choices={getLanguages()} />
			<TextInput disabled source="platforms" label="Platforms" />
			<TextInput disabled source="votes" label="Votes" />
			<TextInput disabled source="memberCount" label="Member Count" />
			<TextInput source="discordLink" label="Discord Link" />
			<GuildMembersList />
		</SimpleForm>
	</Edit>
);
